import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import { useSelector } from 'react-redux';

import { selectAccountId } from '@/redux/session/selectors';
import { computeSessionBoundDate } from '@/util/dateUtils';
import { isUuid } from '@/util/util';

type SessionMeaningful = { rows: { session_id: string; is_meaningful: boolean }[] };

export const SESSION_MEANINGFUL = gql`
  query GetSessionMeaningful($accountId: uuid, $sessionId: String, $startDate: timestamp) {
    rows: list_sessions(
      args: { account_id: $accountId, session_id: $sessionId, start_time: $startDate }
    ) {
      session_id
      is_meaningful
    }
  }
`;

export const useSessionMeaningful = (
  sessionId?: string,
  sessionStart?: string
): boolean | undefined => {
  const accountId = useSelector(selectAccountId);
  const startDate = sessionStart ? computeSessionBoundDate(sessionStart) : undefined;

  const { data } = useQuery<SessionMeaningful>(SESSION_MEANINGFUL, {
    variables: { accountId, sessionId, startDate },
    skip: !sessionId || !accountId || !startDate || !isUuid(sessionId),
  });

  return data?.rows?.[0]?.is_meaningful;
};
